/** Anthro AI chat API — separate from portal AxiosInstance. */

export const ANTHRO_AI_BASE_URL = String(
  import.meta.env.VITE_ANTHRO_AI_BASE_URL || "https://ai.zanta.health",
).replace(/\/$/, "");

/** Default org IDs sent with every chat request. */
export const ANTHRO_AI_DEFAULT_ALLOWED_ORG_IDS =
  "69a567bb77ca240f77da2cf3,69b2be38c783a68721c09ee0,6a4e0a5aOd478bdaea272456";

export const ANTHRO_AI_COGNITO_URL = String(
  import.meta.env.VITE_ANTHRO_AI_COGNITO_URL ||
    "https://cognito-idp.us-east-1.amazonaws.com/",
).trim();

export const ANTHRO_AI_COGNITO_AUTH_HEADERS = {
  "Content-Type": "application/x-amz-json-1.1",
  "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth",
} as const;

export const ANTHRO_AI_COGNITO_AUTH_BODY = {
  AuthFlow: "USER_PASSWORD_AUTH",
  ClientId: "5kef5gkrb3ih6cc3b00u295hp4",
  AuthParameters: {
    USERNAME: "saatvikb@anthro.care",
    PASSWORD: "PermPass123!",
  },
} as const;

const LS_TOKEN_KEY = "anthroAiIdToken";
const LS_EXPIRES_KEY = "anthroAiIdTokenExpiresAt";

let cachedIdToken = "";

function getJwtExpiryMs(token: string): number {
  const payload = token.split(".")[1];
  if (!payload) return 0;
  try {
    const padded = payload.replace(/-/g, "+").replace(/_/g, "/");
    const parsed = JSON.parse(atob(padded)) as { exp?: number };
    return typeof parsed.exp === "number" ? parsed.exp * 1000 : 0;
  } catch {
    return 0;
  }
}

export function setAnthroAiIdToken(token: string, expiresInSeconds?: number) {
  cachedIdToken = String(token || "").trim();
  if (!cachedIdToken) return;

  const expiresAt =
    typeof expiresInSeconds === "number" && expiresInSeconds > 0
      ? Date.now() + expiresInSeconds * 1000
      : getJwtExpiryMs(cachedIdToken);

  try {
    localStorage.setItem(LS_TOKEN_KEY, cachedIdToken);
    if (expiresAt > 0) {
      localStorage.setItem(LS_EXPIRES_KEY, String(expiresAt));
    }
  } catch {
    // localStorage may be unavailable
  }
}

export function getAnthroAiIdToken(): string {
  if (cachedIdToken) return cachedIdToken;

  try {
    const token = String(localStorage.getItem(LS_TOKEN_KEY) || "").trim();
    const expiresAt = Number(localStorage.getItem(LS_EXPIRES_KEY) || 0);
    if (token && (!expiresAt || expiresAt > Date.now())) {
      cachedIdToken = token;
      return token;
    }
  } catch {
    // ignore
  }

  return "";
}

export function getAnthroAiUserId(): string {
  const token = getAnthroAiIdToken();
  const payload = token.split(".")[1];
  if (!payload) return "";
  try {
    const padded = payload.replace(/-/g, "+").replace(/_/g, "/");
    const parsed = JSON.parse(atob(padded)) as {
      sub?: string;
      "cognito:username"?: string;
    };
    return String(parsed.sub || parsed["cognito:username"] || "").trim();
  } catch {
    return "";
  }
}
